import * as PIXI from "pixi.js";

import { SingleInstanceClass } from "@src/core/utils/SingleInstanceClass";
import { IView } from "@src/core/game/components/IView";
import {
  Assets,
  ProgressCallback,
  TAssetData,
  TAssetAlias,
} from "@src/core/assets/Assets";

export abstract class Screen extends SingleInstanceClass implements IView {
  public abstract get assets(): Record<TAssetAlias, TAssetData>;

  private _view: PIXI.Container = new PIXI.Container();
  public get view(): PIXI.Container {
    return this._view;
  }

  private static _loadedScreens = new Set<Function>();

  public static get isLoaded(): boolean {
    return Screen._loadedScreens.has(this);
  }

  public static async load<T extends Screen>(
    this: new () => T,
    progressCallback?: ProgressCallback,
  ): Promise<T> {
    const screen: T = new this();
    await Assets.loadAssets(screen.assets, progressCallback);

    screen.onLoadedAssets();

    Screen._loadedScreens.add(this);

    return screen;
  }

  public static async unload(screen: Screen): Promise<void> {
    await Assets.unloadAssets(screen.assets);

    Screen._loadedScreens.delete(screen.constructor);
  }

  protected onLoadedAssets(): void {}
}
